import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M19.438 3.563v14.874H4.563V3.563h14.875zM5 2c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H5z"
}), 'BoxUnchecked', {
  viewBox: '0 0 24 22'
});